import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login/Loggin'
import Recover from '@/views/login/Recover'
import Admin from '@/components/Admin'
import Layout from '@/views/layout/Layout'
import Front from '@/views/layout/Front'
import Home from '@/views/Home'
import Password from '@/views/Password'
import EmployeeDataIndex from '@/views/employee/index'
import EmployeeData from '@/views/employee/EmployeeData'
import EmployeeDataEdit from '@/views/employee/EmployeeDataEdit'
import BankDataEdit from '@/views/employee/BankDataEdit'
import Modelo145Index from '@/views/modelo145/index'
import Modelo145 from '@/views/modelo145/Modelo145'
import Modelo145Edit from '@/views/modelo145/Modelo145Edit'
import Dashboard from '@/views/tablon/Dashboard'
import UserConfiguration from '@/views/UserConfiguration'
import Mantenimiento from '@/views/Mantenimiento'
import Update from '@/views/Update'
import {Params} from '@/_utils/params'
import Cookies from 'js-cookie';

Vue.use(Router)

let rootBase = Params.requestParam('root-base');

export const router = new Router({
    mode: 'history',
    base: rootBase == null ? '/' : (rootBase + 'p/'),
    routes: [
        {
            path: '*',
            redirect: { name: 'start' },
        },
        {
            name: 'Front',
            path: '/',
            component: Front,
            children: [
                {
                    name: 'start',
                    path: '/',
                    component: Login,
                    default: true
                },
                {
                    name: 'mantenimiento',
                    path: '/mantenimiento',
                    component: Mantenimiento,
                    default: true
                },
                {
                    name: 'reset',
                    path: '/reset',
                    props: route => ({ token: route.query.token || null }),
                    component: Recover
                }
            ]
        },        
        {
            name: 'syslg',
            path: '/syslg',
            component: Admin,
        },
        {
            name: 'update',
            path: '/update',
            component: Update,
        },
        {
            name: 'Layout',
            path: '/',
            component: Layout,
            children: [
            {
                name: 'home',
                path: '/home',
                component: Home,
                meta: {icon: 'ms-Icon ms-Icon--Home'}
            },            
            {
                name: 'dashboard',
                path: '/dashboard',
                component: Dashboard,
                props: true,
                meta: {icon: 'ms-Icon ms-Icon--News'},
            },
            {
                name: 'employee',
                path: '/employee',
                component: EmployeeDataIndex,
                meta: {icon: 'ms-Icon ms-Icon--FabricUserFolder'},
                children: [
                    {
                        name: 'employee',
                        path: '',
                        component: EmployeeData
                    },
                    {
                        name: 'employee-edit',
                        path: '/employee/edit',
                        component: EmployeeDataEdit,
                        props: true,
                    },
                    {
                        name: 'bank-edit',
                        path: '/bank/edit',
                        component: BankDataEdit,
                        props: true,
                    }
                ]
            },
            {
                name: 'model145',
                path: '/model145',
                component: Modelo145Index,
                meta: {icon: 'ms-Icon ms-Icon--AccountManagement'},
                children: [
                    {
                        name: 'model145',
                        path: '',
                        component: Modelo145
                    },
                    {
                        name: 'model145-edit',
                        path: '/model145/edit',
                        component: Modelo145Edit,
                        props: true,
                    }
                ]
            },
            {
                name: 'dashboard',
                path: '/dashboard/:idNoticia',
                component: Dashboard,
                props: true,
                meta: {icon: 'ms-Icon ms-Icon--News', hide: true},
            },
            {
                name: 'change_password',
                path: '/change_password',
                component: Password,
                meta: {icon: 'ms-Icon ms-Icon--PermissionsSolid', hide: true}
            },
            {
                name: 'configuration',
                path: '/configuration',
                component: UserConfiguration,
                meta: {icon: 'ms-Icon ms-Icon--ConfigurationSolid', hide: true},
            },]
        }]
})

router.beforeEach((to, from, next) => {

    //redireccion a la pagina de mantenimiento
    if(to.name!='mantenimiento' && Vue.prototype.$Params['mantenimiento'] && Vue.prototype.$Params.mantenimiento=='1')
        return next({ name: 'mantenimiento' })
    
    //si estamos en la pagina de mantenimiento y en la configuracion ya no esta activo el mantenimiento
    //if(to.name=='mantenimiento' && Vue.prototype.$Params['mantenimiento'] && Vue.prototype.$Params.mantenimiento=='0')
      ///  return next({ name: 'start' })
      
    let _cookieChangePassword = Cookies.get("needChangePassword");
    _cookieChangePassword === 'undefined' ? false : _cookieChangePassword;
    if(to.matched[0].name=='Layout' && to.name!='change_password' && _cookieChangePassword == "true")
    {
        return next({ name: 'change_password' })
    }
    

    //estamos en una pagina logeada, y es obligatoria tener activado el MFA, por eso redireccionamos
    if(to.matched[0].name=='Layout' && to.name!='configuration' && Vue.prototype.$Params.requires_authenticator=='1' && _cookieChangePassword!="true"){
        return next({ name: 'configuration' })
    }
    
    
    //si estamos en el panel Summar y en no somos userSummar
    if(to.name=='syslg' && to.query.sys == undefined && (!Vue.prototype.$Params['isadmin'] || Vue.prototype.$Params.isadmin==0))
        return next({ name: 'start' })
      
    next();
});